// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_mPeTD","icon":"index_icon_V8r9i"};